import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding: 0 0 48px 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      padding: 0 0 32px 0;
    }
  `}
`;

export const BackButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 0;
  padding: 12px;
`;

export const BackButtonLabel = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.brand.primaryMedium};
    font-weight: ${theme.v2.font.weights.medium};
    display: inline-block;
  `}
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;
